module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Metz Architekten","short_name":"Metz Architekten","start_url":"/","background_color":"#111111","theme_color":"#111111","display":"minimal-ui","icon":"src/images/app-icon.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"5645dd6424bc97473081730e9581a423"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
